import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Users,
  Coins, // Changed from HandCoins to Coins
  HeartHandshake,
  Facebook,
  Twitter,
  Instagram,
} from "lucide-react";

const ContactUs = () => {
  return (
    <div className="w-full bg-[#FCFCFC]">
      {/* HERO SECTION */}
      <div className="w-full bg-gradient-to-r from-teal-600 to-green-500 py-20 text-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Get in Touch with DonatePe
          </h1>
          <p className="text-lg opacity-90">
            We're here to help you start, manage, and grow your fundraising
            journey.
          </p>
        </div>
      </div>

      {/* STATS SECTION */}
      <div className="max-w-6xl mx-auto px-4 -mt-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <Users className="mx-auto text-teal-600 mb-2" size={36} />
            <h3 className="text-2xl font-bold">50,000+</h3>
            <p className="text-gray-500">Fundraisers Created</p>
          </div>
          <div>
            <Coins className="mx-auto text-teal-600 mb-2" size={36} /> {/* Changed from HandCoins to Coins */}
            <h3 className="text-2xl font-bold">₹120+ Crores</h3>
            <p className="text-gray-500">Funds Raised</p>
          </div>
          <div>
            <HeartHandshake className="mx-auto text-teal-600 mb-2" size={36} />
            <h3 className="text-2xl font-bold">1,00,000+</h3>
            <p className="text-gray-500">Donors Supported</p>
          </div>
        </div>
      </div>

      {/* MAIN CONTACT SECTION */}
      <div className="max-w-6xl mx-auto px-4 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* LEFT SIDE - INFO */}
        <div className="space-y-6">
          <h2 className="text-3xl font-bold text-gray-900">
            Contact DonatePe Support
          </h2>
          <p className="text-gray-600 text-lg">
            Whether you need help starting a fundraiser, managing donations, or
            partnerships, our team is always ready to support you.
          </p>

          <div className="bg-white rounded-2xl shadow-lg p-6 space-y-5">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-600">
                <Phone size={24} />
              </div>
              <div>
                <h4 className="font-semibold text-lg">Customer Support</h4>
                <p className="text-gray-500">+91 98765 43210</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-600">
                <Mail size={24} />
              </div>
              <div>
                <h4 className="font-semibold text-lg">Email Support</h4>
                <p className="text-gray-500">support@donatepe.com</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-600">
                <MapPin size={24} />
              </div>
              <div>
                <h4 className="font-semibold text-lg">Head Office</h4>
                <p className="text-gray-500">Hyderabad, Telangana, India</p>
              </div>
            </div>
          </div>

          {/* SOCIAL MEDIA */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h4 className="text-lg font-semibold mb-3">Follow Us</h4>
            <div className="flex gap-4">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 hover:bg-teal-600 hover:text-white transition cursor-pointer">
                <Facebook size={20} />
              </div>
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 hover:bg-teal-600 hover:text-white transition cursor-pointer">
                <Twitter size={20} />
              </div>
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 hover:bg-teal-600 hover:text-white transition cursor-pointer">
                <Instagram size={20} />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - FORM */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h3 className="text-2xl font-bold mb-6">Send us a Message</h3>

          <form className="space-y-5">
            <div>
              <label className="text-sm font-semibold text-gray-600">
                Full Name
              </label>
              <input
                type="text"
                placeholder="Enter your name"
                className="w-full mt-1 px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div>
              <label className="text-sm font-semibold text-gray-600">
                Email Address
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full mt-1 px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div>
              <label className="text-sm font-semibold text-gray-600">
                Purpose
              </label>
              <select className="w-full mt-1 px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option>General Query</option>
                <option>Start a Fundraiser</option>
                <option>Donation Issue</option>
                <option>Partnership</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-semibold text-gray-600">
                Message
              </label>
              <textarea
                rows="4"
                placeholder="Write your message..."
                className="w-full mt-1 px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500"
              ></textarea>
            </div>

            <button className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-3 rounded-xl transition">
              Submit Request
            </button>
          </form>
        </div>
      </div>

      {/* FAQ MINI SECTION */}
      <div className="bg-white py-14">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 mb-8">
            Quick answers to common questions about DonatePe.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#f3faf6] p-6 rounded-xl shadow-sm">
              <h4 className="font-semibold mb-2">How to start a fundraiser?</h4>
              <p className="text-gray-600 text-sm">
                You can start a fundraiser in just 2 minutes by signing up on
                DonatePe.
              </p>
            </div>

            <div className="bg-[#f3faf6] p-6 rounded-xl shadow-sm">
              <h4 className="font-semibold mb-2">How to withdraw funds?</h4>
              <p className="text-gray-600 text-sm">
                Funds can be withdrawn directly to your bank account anytime.
              </p>
            </div>

            <div className="bg-[#f3faf6] p-6 rounded-xl shadow-sm">
              <h4 className="font-semibold mb-2">Is DonatePe secure?</h4>
              <p className="text-gray-600 text-sm">
                Yes, DonatePe uses secure payment gateways and verified
                fundraisers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;